import axios from 'axios';
import { Modal } from 'mui';
import { langParams } from '@/utils/tool';

export default {
    data() {
        const orderType = [
            {
                label: this.$t('ApplyReceiveMgnView.AFFIRM_FLAG1'), // 委外请领单
                value: 1,
            },
            {
                label: this.$t('ApplyReceiveMgnView.AFFIRM_FLAG2'), // 委外超领单
                value: 2,
            },
            {
                label: this.$t('ApplyReceiveMgnView.AFFIRM_FLAG3'), // 委外红冲单
                value: 3,
            },
        ];
        return {
            INT_WX_IMPT_STATUS: [],
            INT_REQ_MODE: [],
            INT_REQ_STATUS: [],
            INT_REQ_APPROVED_STATUS: [],
            INT_WXQL_MANUALLY_ADD_PO: [],
            orderType,
            orgList: [],
        };
    },
    methods: {
        setSelectVal(key, values) {
            if (this.formData) {
                const obj = this.getFormDataItemObj(this.formData.items, key);
                obj.options.values = values;
            }
        },
        api(method, url, data, cb) {
            Object.assign(data, {
                language: langParams(this.$i18n.locale),
            });
            return new Promise((resolve, reject) => {
                axios({
                    url,
                    method,
                    data,
                    params: method === 'get' ? data : undefined,
                }, data)
                    .then((res) => {
                        const { code, message: content, data: reData, ...others } = res.data.data;
                        if (code === 1) {
                            if (cb) {
                                cb(reData, others);
                            }
                            resolve();
                        } else {
                            Modal.warning({
                                content,
                            });
                            reject();
                        }
                    })
                    .catch(() => {
                        Modal.error({
                            title: this.$t('common.warn'),
                            content: this.$t('common.error1'),
                        });
                        reject();
                    });
            });
        },
        postApi(url, data, cb) {
            return this.api('post', url, data, cb);
        },
        getApi(url, data, cb) {
            return this.api('get', url, data, cb);
        },
    },
    mounted() {
        /* 模式 */
        this.getDict('INT_REQ_MODE', (data) => {
            this.setSelectVal('wxMode', data);
        });
        /* 单据状态 */
        this.getDict('INT_REQ_STATUS', (data) => {
            this.setSelectVal('status', data);
        });
        /* 审批状态 */
        this.getDict('INT_REQ_APPROVED_STATUS', (data) => {
            this.setSelectVal('approvalStatus', data);
        });
        /* 新增采购订单开关 */
        this.getDict('INT_WXQL_MANUALLY_ADD_PO');
        /* 审批人 */
        this.getDict('INT_WX_BUYER_APPROVED');
        /* 报关状态 */
        this.getDict('INT_WX_IMPT_STATUS');
        this.getSRMInvLovListNew((data) => {
            this.orgList = data.map(({ organizationCode: value, organizationName: label }) => {
                return {
                    value,
                    label,
                };
            });
            const org = this.formData && this.getFormDataItemObj(this.formData.items, 'organizationCode');
            if (org) {
                org.options.values = this.orgList;
            }
        });
        this.setSelectVal('orderType', this.orderType);
    },
};
